'use client';

import React from 'react';

const PageIntroduction = () => {
  return (
    <section className="py-32 lg:py-40 bg-white border-b border-gray-200">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="mb-12">
            <span className="inline-block px-4 py-2 bg-gray-100 text-sm font-semibold text-gray-700 uppercase tracking-wider mb-6">
              Standards Paper
            </span>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold font-headline text-[#0A2540] leading-tight mb-8">
              AI Change Leadership
            </h1>
            <div className="w-24 h-1 bg-[#0A2540] mb-8"></div>
          </div>

          <div className="space-y-6 text-lg text-gray-800 font-body leading-relaxed">
            <p>
              This document establishes AI Change Leadership as a new organisational discipline — distinct from traditional change management, digital transformation, and AI strategy.
            </p>
            <p>
              AI is no longer experimental. It is systemic. Its impact is continuous, not episodic. It reshapes decisions, workflows, roles, and accountability simultaneously across organisations and public institutions.
            </p>
            <p>
              Existing change and transformation models were designed for stable end states and discrete projects. They are insufficient for the pace, scope, and continuity of AI-driven change.
            </p>
            <p>
              This page defines the discipline, articulates its foundations, and introduces a cross-sector reference model for leading continuous, organisation-wide transformation at the pace AI evolves.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageIntroduction;